import constants from './constants';

export const reducer = (state = {}, {action, type, id, callback, priority = 10}) => {
    const event = state[type] ? state[type] : new Map();
    switch (action) {
        case constants.ADD_ACTION:
            event.set(id, {callback, priority});
            return {...state, [type]: event};
        case constants.REMOVE_ACTION:
            event.delete(id);
            return {...state, [type]: event};
    }
    return state;
}